module.exports = __webpack_public_path__ + "0f083ff6084cd1cb0aabc7bbd1014dd1.pdf";